import React from 'react';
import Svg from 'src/components/Svg';

export const FindingStatus = {
  Approved: 'Approved',
  NotRequired: 'not_required',
  Pending: 'Pending',
  Rejected: 'Rejected',
};

/**
 * @type {Closed: string, NotRequired: string, Open: string}
 * new types to match CAP job finding statuses
 * which is now different from CAP Action statuses(FindingStatus)
 */
export const FindingSectionStatus = {
  Open: 'Open',
  Closed: 'Closed',
  NotRequired: 'not_required',
};

/**
 * @type {{Action: string, Finding: string}}
 * additional constant to maintain separation between CAP finding and CAP Action statuses
 * to conditional rendering in CapMultiButtonSwitchField.
 */
export const Sections = {
  Finding: 'finding',
  Action: 'action',
  CapOverallStatus:'CapOverallStatus'
};

export const JobExternalStakeholderRole = {
  FACTORY: 'factory',
  VENDOR: 'vendor',
};

export const JobExternalStakeholderRoleTranslation = {
  [JobExternalStakeholderRole.FACTORY]: 'FACTORY',
  [JobExternalStakeholderRole.VENDOR]: 'VENDOR',
};

export const JobExternalStakeholdersPopupType = {
  AddExisting: 'ADD_EXISTING',
  AddNew: 'ADD_NEW',
};

export const ServiceType = 'cap';

/*
 *lengthy values to create unique and appropriate mapping keys in translation files
 */
export const CapOverallStatuses = {
  Null: 'Cap Overall Status NA',
  CapPending: 'Cap Overall Status Pending',
  CapNeedsRevision: 'Cap Overall Status Needs Revision',
  CapNotAccepted: 'Cap Overall Status Not Accepted',
  CapAccepted: 'Cap Overall Status Accepted'
};

/*
 *Added options required for cap overall status with originalValue and key
 */
export const CapOverallStatusesOption = [
  { label: 'N/A', value: 'N/A', key: 'Null', originalValue: 'Cap Overall Status NA', backgroundColor: '#b8b8b8', showLabel: false },
  { label: 'CAP Pending', value: 'CAP Pending', key: 'CapPending', originalValue: 'Cap Overall Status Pending', backgroundColor: '#b8b8b8', showLabel: false },
  { label: 'CAP Needs Revision', value: 'CAP Needs Revision', key: 'CapNeedsRevision', originalValue: 'Cap Overall Status Needs Revision', backgroundColor: '#b8b8b8', showLabel: false },
  { label: 'CAP Not Accepted', value: 'CAP Not Accepted', key: 'CapNotAccepted', originalValue: 'Cap Overall Status Not Accepted', backgroundColor: '#db5034', showLabel: false },
  { label: 'CAP Accepted', value: 'CAP Accepted', key: 'CapAccepted', originalValue: 'Cap Overall Status Accepted', backgroundColor: '#73b76a', showLabel: false },
];

export const FindingSectionStatusOption = [
  { label: 'Open', value: 'Open', key: 'Open', originalValue: 'Open', backgroundColor: '#b8b8b8', showLabel: false, chipIcon: 'hourglass-o' },
  { label: 'Closed', value: 'Closed', key: 'Closed', originalValue: 'Closed', backgroundColor: '#73b76a', showLabel: false, chipIcon: 'check' },
  { label: 'Not required', value: 'Not required', key: 'not_required', originalValue: 'not_required', backgroundColor: '#b8b8b8', showLabel: false, chipIcon: 'hourglass-o' },
];

export const FindingStatusOption = [
  { label: 'Approved', value: 'Approved', key: 'Approved', originalValue: 'Approved', backgroundColor: '#55b047', showLabel: false, chipIcon: 'check' },
  { label: 'Not required', value: 'Not required', key: 'not_required', originalValue: 'not_required', backgroundColor: '#f26f23', showLabel: false, chipIcon: 'ban' },
  { label: 'Pending', value: 'Pending', key: 'Pending', originalValue: 'Pending', backgroundColor: '#ffcc00', showLabel: false,  CustomChipIcon: <span className='u-mr-10 l-flex ai-center'><Svg name="pending" style={{padding: '0px',height: '20px'}}/></span> },
  { label: 'Rejected', value: 'Rejected', key: 'Rejected', originalValue: 'Rejected', backgroundColor: '#e32332', showLabel: false, chipIcon: 'close' },
];
